<template>
  <vs-popup class="customer-credit-note-pop-up"
            id="popup"
            title="CREATE CUSTOMER CREDIT NOTE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateCreditNote)" autocomplete="off">


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="credit_amount" name="credit_amount" rules="" v-slot="{ errors }">
                <small class="label"><span class="text-bold">Credit amount </span></small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{account_currency}}</span>
                    </div>
                  </template>
                  <vs-input v-model="createForm.credit_amount"  name="credit_amount" class="w-full" label=""/>
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="belongs_to_product_order_id" name="belongs_to_product_order_id" rules="required" v-slot="{ errors }">
                <small class="label">Original invoice raised against</small>
                <v-select :clearable="false" label="product_order_code" v-model="createForm.belongs_to_product_order_id" :reduce="option => option.id" :options="product_orders" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {},
      credit_limit: '',
      isDataAvailable: false,
      product_orders: [],
    }
  }

export default {
  name: 'CreateCustomerCreditNotePopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        this.open = true;
        await this.fetchCustomerAccountCredit()
        await this.fetchCustomerProductOrders()
      } catch (error) {

      }
    },
    async onClickCreateCreditNote () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.customer_id = this.id

         // format decimal places
         this.createForm.credit_amount = (Number(this.createForm.credit_amount)).toFixed(2)

         await CustomerRepository.createCustomerCreditNote(this.createForm)
         this.showSuccessMessage('Customer credit note created successfully')
         vue.open = false;
         await vue.$parent.refreshData()
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchCustomerAccountCredit(){
      this.$vs.loading()
      try {
        const {data} = await CustomerRepository.getCustomerAccountCredit(this.id)
        this.credit_limit = data.data.credit_limit
        this.isDataAvailable = true
      } catch (e) {
        // this.convertAndNotifyError(e)
        this.isDataAvailable = false
        this.credit_limit = '-'
      }
      this.$vs.loading.close()
    },
    async fetchCustomerProductOrders(){
      this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getListOfProductOrders(this.id, 1, '', 100, '')).data
        this.product_orders = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-credit-note-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
